var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94453 12.9716V10.8633H12.0529V12.9716H9.94453ZM6.27786 12.9716V10.8633H8.3862V12.9716H6.27786ZM13.6112 12.9716V10.8633H15.7195V12.9716H13.6112ZM9.94453 16.6383V14.5299H12.0529V16.6383H9.94453ZM6.27786 16.6383V14.5299H8.3862V16.6383H6.27786ZM13.6112 16.6383V14.5299H15.7195V16.6383H13.6112ZM2.17578 20.7404V2.61328H5.61328V1.23828H7.49245V2.61328H14.5049V1.23828H16.3841V2.61328H19.8445V20.7404H2.17578ZM4.32995 18.5862H17.6674V8.93828H4.32995V18.5862ZM4.32995 7.56328H17.6674V4.79036H4.32995V7.56328ZM4.32995 7.56328V4.79036V7.56328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.17f94e4507bc5a636754f388c1b18c7a.svg";
export { ForwardRef as ReactComponent };